import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'accountNumberMask'
})
export class AccountNumberMaskPipe implements PipeTransform {
    transform(value: string): string {
        if (value) {
            return value.replace(/\d(?=\d{4})/g, "*");
        } else {
            return '';
        }
    }
}